import _createForOfIteratorHelper from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import React from 'react';
import { randomId } from '@mantine/hooks';
import { Text } from '../../Text/Text.js';
import { Divider } from '../../Divider/Divider.js';
import useStyles from './SelectItems.styles.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
function SelectItems(_ref) {
  var data = _ref.data,
    hovered = _ref.hovered,
    classNames = _ref.classNames,
    styles = _ref.styles,
    isItemSelected = _ref.isItemSelected,
    uuid = _ref.uuid,
    __staticSelector = _ref.__staticSelector,
    onItemHover = _ref.onItemHover,
    onItemSelect = _ref.onItemSelect,
    itemsRefs = _ref.itemsRefs,
    Item = _ref.itemComponent,
    size = _ref.size,
    nothingFound = _ref.nothingFound,
    creatable = _ref.creatable,
    createLabel = _ref.createLabel,
    unstyled = _ref.unstyled;
  var _useStyles = useStyles({
      size: size
    }, {
      classNames: classNames,
      styles: styles,
      unstyled: unstyled,
      name: __staticSelector
    }),
    classes = _useStyles.classes;
  var unGroupedItems = [];
  var groupedItems = [];
  var creatableDataIndex = null;
  var constructItemComponent = function constructItemComponent(item, index) {
    var selected = typeof isItemSelected === "function" ? isItemSelected(item.value) : false;
    return /* @__PURE__ */React.createElement(Item, __spreadValues({
      key: item.value,
      className: classes.item,
      "data-disabled": item.disabled || void 0,
      "data-hovered": !item.disabled && hovered === index || void 0,
      "data-selected": !item.disabled && selected || void 0,
      selected: selected,
      onMouseEnter: function onMouseEnter() {
        return onItemHover(index);
      },
      id: "".concat(uuid, "-").concat(index),
      role: "option",
      tabIndex: -1,
      "aria-selected": hovered === index,
      ref: function ref(node) {
        if (itemsRefs && itemsRefs.current) {
          itemsRefs.current[item.value] = node;
        }
      },
      onMouseDown: !item.disabled ? function (event) {
        event.preventDefault();
        onItemSelect(item);
      } : null,
      disabled: item.disabled
    }, item));
  };
  var groupName = null;
  data.forEach(function (item, index) {
    if (item.creatable) {
      creatableDataIndex = index;
    } else if (!item.group) {
      unGroupedItems.push(constructItemComponent(item, index));
    } else {
      if (groupName !== item.group) {
        groupName = item.group;
        groupedItems.push( /* @__PURE__ */React.createElement("div", {
          className: classes.separator,
          key: "__mantine-divider-".concat(index)
        }, /* @__PURE__ */React.createElement(Divider, {
          classNames: {
            label: classes.separatorLabel
          },
          label: item.group
        })));
      }
      groupedItems.push(constructItemComponent(item, index));
    }
  });
  if (creatable) {
    var creatableDataItem = data[creatableDataIndex];
    unGroupedItems.push( /* @__PURE__ */React.createElement("div", {
      key: randomId(),
      className: classes.item,
      "data-hovered": hovered === creatableDataIndex || void 0,
      onMouseEnter: function onMouseEnter() {
        return onItemHover(creatableDataIndex);
      },
      onMouseDown: function onMouseDown(event) {
        event.preventDefault();
        onItemSelect(creatableDataItem);
      },
      tabIndex: -1,
      ref: function ref(node) {
        if (itemsRefs && itemsRefs.current) {
          itemsRefs.current[creatableDataItem.value] = node;
        }
      }
    }, createLabel));
  }
  if (groupedItems.length > 0 && unGroupedItems.length > 0) {
    unGroupedItems.unshift( /* @__PURE__ */React.createElement("div", {
      className: classes.separator,
      key: "empty-group-separator"
    }, /* @__PURE__ */React.createElement(Divider, null)));
  }
  return groupedItems.length > 0 || unGroupedItems.length > 0 ? /* @__PURE__ */React.createElement(React.Fragment, null, groupedItems, unGroupedItems) : /* @__PURE__ */React.createElement(Text, {
    size: size,
    unstyled: unstyled,
    className: classes.nothingFound
  }, nothingFound);
}
SelectItems.displayName = "@mantine/core/SelectItems";
export { SelectItems };